import { render, staticRenderFns } from "./CustomDeleteDialog.vue?vue&type=template&id=07b414d2&scoped=true"
import script from "./CustomDeleteDialog.vue?vue&type=script&lang=js"
export * from "./CustomDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomDeleteDialog.vue?vue&type=style&index=0&id=07b414d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b414d2",
  null
  
)

export default component.exports